var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSichos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,95.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241 797 c-58 -13 -57 -11 -116 -196 -5 -16 5 -18 140 -17 l145 1 0 102 c0 102 0 102 -37 112 -45 13 -61 13 -132 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 797 c-35 -12 -35 -12 -38 -112 l-3 -100 151 0 c93 0 150 4 150 10 -1 19 -50 179 -58 187 -24 24 -149 33 -202 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 509 c-14 -22 17 -24 401 -24 371 0 394 1 394 17 0 22 -782 28 -795 7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,95.000000) scale(0.100000,-0.100000)",
    fill: "#D6E4F5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245 809 c-27 -6 -55 -15 -61 -22 -10 -10 -74 -191 -74 -208 0 -3 70 -5 155 -5 l155 1 0 107 c0 96 -2 108 -20 118 -30 16 -99 20 -155 9z m128 -10 c37 -10 37 -10 37 -112 l0 -102 -145 -1 c-135 -1 -145 1 -140 17 59 185 58 183 116 196 71 15 87 15 132 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 806 c-40 -12 -40 -12 -40 -121 l0 -109 158 0 c180 -1 169 -9 136 100 -37 126 -33 121 -103 133 -76 13 -99 13 -151 -3z m146 -6 c29 -6 57 -14 61 -18 8 -8 57 -168 58 -187 0 -6 -57 -10 -150 -10 l-151 0 3 100 c3 100 3 100 38 112 44 15 74 16 141 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 515 c-18 -46 -19 -45 408 -43 403 3 403 3 406 31 3 27 3 27 -403 27 -351 0 -406 -2 -411 -15z m806 -13 c0 -16 -23 -17 -394 -17 -384 0 -415 2 -401 24 13 21 795 15 795 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674 255 c0 -77 2 -107 3 -67 2 40 2 103 0 140 -2 37 -3 4 -3 -73z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,95.000000) scale(0.100000,-0.100000)",
    fill: "#2F7ED2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403 799 c14 -8 17 -27 19 -122 l2 -112 3 109 c4 106 -3 136 -31 136 -6 0 -3 -5 7 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 573 c28 -2 76 -2 105 0 28 2 5 3 -53 3 -58 0 -81 -1 -52 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 573 c29 -2 74 -2 100 0 26 2 2 3 -53 3 -55 0 -76 -1 -47 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 418 c-7 -7 -12 -16 -12 -22 0 -5 6 -2 13 7 9 12 32 17 92 20 l80 3 -80 2 c-52 1 -85 -2 -93 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 403 c37 -2 100 -2 140 0 40 1 10 3 -67 3 -77 0 -110 -1 -73 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273 320 c0 -47 2 -66 4 -42 2 23 2 61 0 85 -2 23 -4 4 -4 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 258 c-1 -75 1 -139 6 -141 4 -3 6 38 4 91 -4 172 -8 190 -10 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 228 c-1 -59 1 -109 6 -111 4 -3 6 29 4 71 -4 135 -9 150 -10 40z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,95.000000) scale(0.100000,-0.100000)",
    fill: "#0C254C",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 836 c-14 -9 -34 -19 -46 -25 -25 -11 -94 -193 -94 -247 0 -34 0 -34 415 -34 415 0 415 0 415 -30 0 -30 0 -30 -415 -30 -408 0 -415 0 -415 -20 0 -18 7 -20 89 -20 105 0 97 14 100 -180 3 -135 5 -147 27 -129 11 9 14 42 14 144 0 132 0 132 53 139 92 11 282 7 295 -6 8 -8 12 -55 12 -143 0 -135 3 -153 27 -134 10 9 13 46 13 148 0 166 -4 161 116 161 85 0 94 2 108 22 22 31 20 70 -4 101 -12 14 -37 76 -56 137 -23 73 -41 113 -52 117 -9 4 -29 15 -43 25 -23 17 -39 19 -150 14 -152 -6 -140 -6 -274 0 -85 3 -116 1 -135 -10z m234 -35 c13 -11 16 -34 16 -122 l0 -109 -124 0 c-68 0 -136 -2 -152 -5 -54 -10 -56 2 -19 115 19 57 39 108 44 113 28 28 204 34 235 8z m281 11 c39 -7 39 -7 66 -92 52 -165 65 -150 -125 -150 l-166 0 0 114 c0 114 0 114 28 124 32 12 139 14 197 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSichos);
export default __webpack_public_path__ + "static/media/sichos.41aec11db5c7e96359cab3feab6fec6b.svg";
export { ForwardRef as ReactComponent };